import { useEffect, useState } from 'react'

export const useABGroup = (cookieName = 'discover-test-group', groups = ['a', 'b'], options = {}) => {
  const {
    cookieExpiry = 30,
    defaultGroup = 'a'
  } = options

  const [group, setGroup] = useState(null)

  useEffect(() => {
    const getCookie = name => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      return match ? match[2] : null
    }

    const setCookie = (name, value, days = cookieExpiry) => {
      const expires = new Date(Date.now() + days * 864e5).toUTCString()
      document.cookie = `${name}=${value}; path=/; expires=${expires}`
    }

    let existingGroup = getCookie(cookieName)

    if (!existingGroup) {
      const assignedGroup = groups[Math.floor(Math.random() * groups.length)]
      setCookie(cookieName, assignedGroup)
      setGroup(assignedGroup)
    } else {
      setGroup(existingGroup)
    }
  }, [cookieName, groups, cookieExpiry])

  return group || defaultGroup
}
